module.exports = __webpack_public_path__ + "static/media/horoscope-icon-6.c8538837.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-6.png
// module id = 1532
// module chunks = 0